/* DeoDap Diwali 2026 – home sections behaviour.
   Ported from the approved design (main.js, mega-menu.js, gift-amount-reel.js, diwali-fireworks.js,
   mobile-dropdowns.js, mobile-banner-wall.js). Every section initialises from its own root
   ([data-dwl]); the theme editor re-runs it on section load. Add to cart uses the real cart. */
(function () {
  'use strict';
  if (window.__dwlHome) return;
  window.__dwlHome = true;

  var DEFS = "<svg id=\"dwl-defs\" width=\"0\" height=\"0\" style=\"position:absolute;width:0;height:0;overflow:hidden\" aria-hidden=\"true\" focusable=\"false\">\n  <defs>\n    <radialGradient id=\"dwl-gGlow\" cx=\"50%\" cy=\"50%\" r=\"50%\"><stop offset=\"0\" stop-color=\"#ffe6a3\" stop-opacity=\".95\"/><stop offset=\".45\" stop-color=\"#ffb347\" stop-opacity=\".45\"/><stop offset=\"1\" stop-color=\"#ff8a00\" stop-opacity=\"0\"/></radialGradient>\n    <linearGradient id=\"dwl-gFlame\" x1=\"0\" y1=\"1\" x2=\"0\" y2=\"0\"><stop offset=\"0\" stop-color=\"#ff6a00\"/><stop offset=\".55\" stop-color=\"#ffb21a\"/><stop offset=\"1\" stop-color=\"#fff2b8\"/></linearGradient>\n    <linearGradient id=\"dwl-gClay\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#e2762b\"/><stop offset=\"1\" stop-color=\"#7a2a0c\"/></linearGradient>\n    <pattern id=\"dwl-toranTile\" width=\"64\" height=\"46\" patternUnits=\"userSpaceOnUse\">\n      <path d=\"M0 4 Q32 14 64 4\" fill=\"none\" stroke=\"#d99a2b\" stroke-width=\"2\"/>\n      <g transform=\"translate(16 8)\"><path d=\"M0 0C7 6 7 18 0 27C-7 18-7 6 0 0Z\" fill=\"#2f7d3a\"/><path d=\"M0 2V25\" stroke=\"#7fbf6a\" stroke-width=\"1\"/></g>\n      <g transform=\"translate(48 8)\" stroke-dasharray=\"2.2 1.4\">\n        <circle cy=\"6\" r=\"5.5\" fill=\"#f59e0b\" stroke=\"#e46d06\" stroke-width=\"3\"/>\n        <circle cy=\"18\" r=\"5\" fill=\"#ffbf2e\" stroke=\"#f08a0a\" stroke-width=\"3\"/>\n        <circle cy=\"29\" r=\"4.5\" fill=\"#f59e0b\" stroke=\"#e46d06\" stroke-width=\"3\"/>\n        <circle cy=\"38\" r=\"2.4\" fill=\"#c8102e\" stroke=\"none\"/>\n      </g>\n    </pattern>\n    <linearGradient id=\"dwl-dpFlame\" x1=\"0\" y1=\"1\" x2=\"0\" y2=\"0\"><stop offset=\"0\" stop-color=\"#ff6a00\"/><stop offset=\".45\" stop-color=\"#ffa41a\"/><stop offset=\"1\" stop-color=\"#ffe7a0\"/></linearGradient>\n    <linearGradient id=\"dwl-dpClay\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#e9823a\"/><stop offset=\".55\" stop-color=\"#a8461a\"/><stop offset=\"1\" stop-color=\"#5e1f08\"/></linearGradient>\n    <linearGradient id=\"dwl-dpOil\" x1=\"0\" y1=\"0\" x2=\"0\" y2=\"1\"><stop offset=\"0\" stop-color=\"#8a4a12\"/><stop offset=\"1\" stop-color=\"#4a2006\"/></linearGradient>\n    <radialGradient id=\"dwl-dpHalo\" cx=\"50%\" cy=\"50%\" r=\"50%\"><stop offset=\"0\" stop-color=\"#ffd98a\" stop-opacity=\".75\"/><stop offset=\".5\" stop-color=\"#ffb347\" stop-opacity=\".25\"/><stop offset=\"1\" stop-color=\"#ffb347\" stop-opacity=\"0\"/></radialGradient>\n    <symbol id=\"dwl-diyaPro\" viewBox=\"0 0 64 56\">\n      <circle class=\"dw-dp-halo\" cx=\"32\" cy=\"18\" r=\"17\" fill=\"url(#dwl-dpHalo)\"/>\n      <g class=\"dw-dp-flame\">\n        <path d=\"M32 4C38 13 40 20 36.2 26C34.6 28.6 33.4 30.4 32 30.4C30.6 30.4 29.4 28.6 27.8 26C24 20 26 13 32 4Z\" fill=\"url(#dwl-dpFlame)\"/>\n        <path class=\"dw-dp-core\" d=\"M32 14C34.8 18.6 35.4 22.2 33.7 25.6C33.1 26.9 32.6 27.8 32 27.8C31.4 27.8 30.9 26.9 30.3 25.6C28.6 22.2 29.2 18.6 32 14Z\" fill=\"#fff6cf\"/>\n      </g>\n      <path d=\"M32 30.2V34.2\" stroke=\"#3a1a08\" stroke-width=\"1.6\" stroke-linecap=\"round\"/>\n      <path d=\"M6 33.5C9 46 20.5 52.5 32 52.5S55 46 58 33.5C50 37 41 38.6 32 38.6S14 37 6 33.5Z\" fill=\"url(#dwl-dpClay)\"/>\n      <ellipse cx=\"32\" cy=\"34\" rx=\"25.6\" ry=\"4.4\" fill=\"url(#dwl-dpOil)\"/>\n      <ellipse cx=\"32\" cy=\"34\" rx=\"25.6\" ry=\"4.4\" fill=\"none\" stroke=\"#f3c26b\" stroke-width=\"1.6\"/>\n      <path d=\"M13 42.5C19 46.5 25 48 32 48S45 46.5 51 42.5\" fill=\"none\" stroke=\"#f3c26b\" stroke-width=\"1\" stroke-opacity=\".6\" stroke-dasharray=\"1.2 2.6\" stroke-linecap=\"round\"/>\n      <circle cx=\"21\" cy=\"43.2\" r=\"1.5\" fill=\"#ffd27a\"/><circle cx=\"32\" cy=\"45.6\" r=\"1.7\" fill=\"#ffd27a\"/><circle cx=\"43\" cy=\"43.2\" r=\"1.5\" fill=\"#ffd27a\"/>\n      <path d=\"M12 38C16 41 20 42.6 24 43.4\" stroke=\"#fff\" stroke-opacity=\".22\" stroke-width=\"2\" stroke-linecap=\"round\" fill=\"none\"/>\n    </symbol>\n    <symbol id=\"dwl-miniDiya\" viewBox=\"0 0 60 50\">\n      <circle cx=\"30\" cy=\"16\" r=\"15\" fill=\"url(#dwl-gGlow)\"/>\n      <path d=\"M30 3C36 12 37 19 30 27C23 19 24 12 30 3Z\" fill=\"url(#dwl-gFlame)\"/>\n      <path d=\"M4 29C8 43 21 47 30 47S52 43 56 29C47 32 39 33 30 33S13 32 4 29Z\" fill=\"url(#dwl-gClay)\"/>\n      <path d=\"M4 29C13 32 21 33 30 33S47 32 56 29\" fill=\"none\" stroke=\"#f3c26b\" stroke-width=\"2\"/>\n    </symbol>\n    <symbol id=\"dwl-spark\" viewBox=\"-10 -10 20 20\"><path d=\"M0-10C1 -2 2-1 10 0C2 1 1 2 0 10C-1 2-2 1-10 0C-2-1-1-2 0-10Z\" fill=\"currentColor\"/></symbol>\n  </defs>\n</svg>";
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var rupee = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };
  var esc = function (t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); };

  function ensureDefs() {
    if (!document.getElementById('dwl-defs')) document.body.insertAdjacentHTML('afterbegin', DEFS);
  }

  /* ---------- decorative helpers ---------- */
  function mandala() {
    var s = '<g fill="none" stroke="currentColor" stroke-width="1.4"><circle r="95"/><circle r="72"/><circle r="48"/><circle r="20"/></g><g fill="currentColor">';
    for (var a = 0; a < 360; a += 30) s += '<path transform="rotate(' + a + ')" d="M0-95C10-80 10-60 0-48C-10-60-10-80 0-48Z"/>';
    for (var b = 15; b < 360; b += 30) s += '<path transform="rotate(' + b + ')" d="M0-70C6-60 6-52 0-46C-6-52-6-60 0-70Z"/><circle transform="rotate(' + b + ')" cy="-32" r="3"/>';
    return s + '</g>';
  }
  function ornament() {
    var o = '<g fill="#e8b44c">';
    for (var a = 0; a < 360; a += 45) o += '<path transform="rotate(' + a + ')" d="M0-19C3.5-14 3.5-9 0-6C-3.5-9-3.5-14 0-19Z"/>';
    o += '</g><g fill="#f59e0b">';
    for (var b = 22; b < 360; b += 45) o += '<circle r="1.6" transform="rotate(' + b + ') translate(0 -11)"/>';
    return o + '</g><circle r="4.5" fill="#c8102e"/><circle r="1.8" fill="#ffd27a"/>';
  }
  function diya(d) {
    return '<svg class="dw-diya" viewBox="0 0 60 50" style="--d:' + d + 's"><circle class="dw-glow" cx="30" cy="16" r="17" fill="url(#dwl-gGlow)"/><path class="dw-flame" d="M30 3C36 12 37 19 30 27C23 19 24 12 30 3Z" fill="url(#dwl-gFlame)"/><path d="M30 22v6" stroke="#3a1a0a" stroke-width="1.5"/><path d="M4 29C8 43 21 47 30 47S52 43 56 29C47 32 39 33 30 33S13 32 4 29Z" fill="url(#dwl-gClay)"/><path d="M4 29C13 32 21 33 30 33S47 32 56 29" fill="none" stroke="#f3c26b" stroke-width="2"/><g fill="#f3c26b"><circle cx="18" cy="39" r="1.4"/><circle cx="30" cy="41.5" r="1.6"/><circle cx="42" cy="39" r="1.4"/></g></svg>';
  }
  function decor(root) {
    $$('.dw-mandala', root).forEach(function (m) { if (!m.childElementCount) m.innerHTML = mandala(); });
    $$('.dwl-orn', root).forEach(function (m) { if (!m.childElementCount) m.innerHTML = ornament(); });
    $$('[data-diyas]', root).forEach(function (el) {
      if (el.childElementCount) return;
      var n = +el.getAttribute('data-diyas') || 9, base = +el.getAttribute('data-delay') || 0, step = +el.getAttribute('data-step') || 0.18, h = '';
      for (var i = 0; i < n; i++) h += diya((base + i * step).toFixed(2));
      el.innerHTML = h;
    });
  }

  /* ---------- photo cards: shimmer, rising sparks, scroll reveal ---------- */
  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (ents) {
    ents.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('dw-in'); revealIO.unobserve(e.target); } });
  }, { threshold: 0.15 }) : null;
  function photoCards(root) {
    $$('.dw-ccard.dw-has-img, .dw-env.dw-has-photo, .dw-day.dw-has-photo', root).forEach(function (el) {
      if (el.getAttribute('data-fx')) return;
      el.setAttribute('data-fx', '1');
      if (el.closest('.dw-cd-track')) return;
      el.classList.add('dw-pcard');
      var sp = document.createElement('span'); sp.className = 'dw-sparks'; sp.setAttribute('aria-hidden', 'true');
      for (var n = 0; n < 7; n++) {
        var i = document.createElement('i');
        i.style.left = (8 + Math.random() * 84) + '%';
        i.style.animationDelay = (-Math.random() * 5).toFixed(2) + 's';
        i.style.animationDuration = (4 + Math.random() * 3).toFixed(2) + 's';
        var z = (3 + Math.random() * 4).toFixed(1) + 'px'; i.style.width = i.style.height = z;
        sp.appendChild(i);
      }
      var sh = document.createElement('span'); sh.className = 'dw-shine'; sh.setAttribute('aria-hidden', 'true');
      el.appendChild(sh); el.appendChild(sp);
      if (!revealIO || el.classList.contains('dw-day') || el.closest('.dw-cd-track')) return;
      var sib = Array.prototype.indexOf.call(el.parentElement.children, el);
      el.style.setProperty('--i', sib % 6);
      el.classList.add('dw-reveal');
      el.addEventListener('animationend', function (e) { if (e.animationName === 'dw-revealUp') el.classList.remove('dw-reveal', 'dw-in'); });
      revealIO.observe(el);
    });
  }

  /* ---------- auto-scrolling belt (GPU transform, seamless loop, drag + arrows) ----------
     The old version moved the row with scrollLeft every frame; browsers round scrollLeft to whole
     pixels, so at ~0.7px/frame the row moved in uneven 0/1px steps (visible stutter). A sub-pixel
     translate3d on its own compositor layer is smooth and does not trigger layout. */
  function belt(track, arrowsRoot, desk, mob) {
    if (!track || track.getAttribute('data-belt')) return;
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return;
    track.setAttribute('data-belt', '1');
    var inner = document.createElement('div'); inner.className = 'dw-belt-in';
    items.forEach(function (c) { inner.appendChild(c); });
    items.forEach(function (c) {
      var k = c.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.setAttribute('tabindex', '-1'); k.removeAttribute('data-shopify-editor-block'); k.removeAttribute('id');
      $$('a,button,input', k).forEach(function (x) { x.setAttribute('tabindex', '-1'); });
      inner.appendChild(k);
    });
    track.appendChild(inner); track.classList.add('dw-belt');
    var L = 0, x = 0, target = null, last = 0, hover = false, hold = 0, visible = false, running = false, drag = null, moved = false;
    var measure = function () { L = inner.children[items.length].offsetLeft - inner.children[0].offsetLeft; };
    var step = function () { return items[0].getBoundingClientRect().width + parseFloat(getComputedStyle(inner).columnGap || 0); };
    var speed = function () { return window.innerWidth < 861 ? mob : desk; };
    var wrap = function () { if (L > 0 && target === null && !drag) { if (x >= L) x -= L; else if (x < 0) x += L; } };
    var apply = function () { inner.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)'; };
    function tick(t) {
      if (!visible || !document.body.contains(track)) { running = false; last = 0; return; }
      var dt = last ? Math.min(0.05, (t - last) / 1000) : 0; last = t;
      if (drag) { /* position set by pointer */ }
      else if (target !== null) { var d = target - x; if (Math.abs(d) < 0.4) { x = target; target = null; } else x += d * Math.min(1, dt * 10); }
      else if (!hover && t > hold && !reduce && !document.hidden) x += speed() * dt;
      wrap(); apply();
      requestAnimationFrame(tick);
    }
    var start = function () { if (!running && visible) { running = true; last = 0; requestAnimationFrame(tick); } };
    var pauseFor = function (ms) { hold = Math.max(hold, performance.now() + ms); };
    measure(); window.addEventListener('resize', function () { measure(); wrap(); apply(); });
    if (arrowsRoot) $$('.dw-arrows button', arrowsRoot).forEach(function (b) {
      b.addEventListener('click', function () {
        var dir = +b.getAttribute('data-dir');
        var base = target === null ? x : target, st = step();
        if (dir < 0 && base - st < 0) { x += L; base += L; }
        if (dir > 0 && base + st > 2 * L - track.clientWidth) { x -= L; base -= L; }
        target = base + dir * st;
        pauseFor(2500); start();
      });
    });
    track.addEventListener('mouseenter', function () { hover = true; });
    track.addEventListener('mouseleave', function () { hover = false; pauseFor(500); });
    track.addEventListener('focusin', function () { hover = true; });
    track.addEventListener('focusout', function () { hover = false; pauseFor(1000); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY, x0: x, on: false }; moved = false; target = null;
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.sx, dy = e.clientY - drag.sy;
      if (!drag.on) { if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) { drag.on = true; moved = true; try { track.setPointerCapture(e.pointerId); } catch (err) {} } else if (Math.abs(dy) > 10) { drag = null; return; } else return; }
      x = drag.x0 - dx; apply();
    });
    var end = function () { if (!drag) return; drag = null; if (L > 0) { while (x >= L) x -= L; while (x < 0) x += L; } pauseFor(2200); };
    track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; if (visible) start(); }); }, { threshold: 0.05 }).observe(track);
    else { visible = true; start(); }
    return { pause: pauseFor };
  }

  /* Back-and-forth glide (no clones): forward at `fwd` px/s to the last item, short rest,
     back at `back` px/s to the first item, short rest, repeat. */
  function pingPong(track, fwd, back) {
    if (!track || track.getAttribute('data-belt')) return null;
    var items = Array.prototype.slice.call(track.children);
    if (items.length < 2) return null;
    track.setAttribute('data-belt', '1');
    var inner = document.createElement('div'); inner.className = 'dw-belt-in';
    items.forEach(function (c) { inner.appendChild(c); });
    track.appendChild(inner); track.classList.add('dw-belt');
    var x = 0, dir = 1, max = 0, last = 0, hold = 0, hover = false, visible = false, running = false, drag = null, moved = false, REST = 900;
    var measure = function () {
      var cs = getComputedStyle(track);
      var view = track.clientWidth - parseFloat(cs.paddingLeft || 0) - parseFloat(cs.paddingRight || 0);
      max = Math.max(0, inner.scrollWidth - view);
    };
    var clamp = function () { if (x < 0) x = 0; if (x > max) x = max; };
    var apply = function () { inner.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)'; };
    var pauseFor = function (ms) { hold = Math.max(hold, performance.now() + ms); };
    function tick(t) {
      if (!visible || !document.body.contains(track)) { running = false; last = 0; return; }
      var dt = last ? Math.min(0.05, (t - last) / 1000) : 0; last = t;
      if (!drag && !hover && t > hold && !reduce && !document.hidden && max > 0) {
        // ease in/out near the ends so the turn feels soft
        var edge = dir > 0 ? max - x : x, ease = Math.max(0.25, Math.min(1, edge / 60, (dir > 0 ? x : max - x) / 40 + 0.25));
        x += dir * (dir > 0 ? fwd : back) * ease * dt;
        if (x >= max) { x = max; dir = -1; pauseFor(REST); }
        else if (x <= 0) { x = 0; dir = 1; pauseFor(REST); }
      }
      apply();
      requestAnimationFrame(tick);
    }
    var start = function () { if (!running && visible) { running = true; last = 0; requestAnimationFrame(tick); } };
    measure(); window.addEventListener('resize', function () { measure(); clamp(); apply(); });
    track.addEventListener('mouseenter', function () { hover = true; });
    track.addEventListener('mouseleave', function () { hover = false; pauseFor(500); });
    track.addEventListener('focusin', function () { hover = true; });
    track.addEventListener('focusout', function () { hover = false; pauseFor(1000); });
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      drag = { id: e.pointerId, sx: e.clientX, sy: e.clientY, x0: x, on: false }; moved = false;
    });
    track.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.sx, dy = e.clientY - drag.sy;
      if (!drag.on) { if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) { drag.on = true; moved = true; try { track.setPointerCapture(e.pointerId); } catch (err) {} } else if (Math.abs(dy) > 10) { drag = null; return; } else return; }
      dir = dx < 0 ? 1 : -1; // keep going the way the shopper pushed it
      x = drag.x0 - dx; clamp(); apply();
    });
    var end = function () { if (!drag) return; drag = null; pauseFor(2200); };
    track.addEventListener('pointerup', end); track.addEventListener('pointercancel', end);
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { es.forEach(function (e) { visible = e.isIntersecting; if (visible) { measure(); start(); } }); }, { threshold: 0.3 }).observe(track);
    else { visible = true; start(); }
    return { pause: pauseFor };
  }

  /* ---------- hero ---------- */
  function initHero(root) {
    var hero = $('.dw-hero', root);
    if (!hero) return;
    // phone banner wall layer: reuse each banner photo
    $$('.dw-hero-art', hero).forEach(function (i) {
      if (i.previousElementSibling && i.previousElementSibling.classList.contains('dw-hero-wall')) return;
      var w = document.createElement('img'); w.className = 'dw-hero-wall'; w.alt = ''; w.setAttribute('aria-hidden', 'true'); w.decoding = 'async'; w.loading = 'lazy';
      w.src = i.getAttribute('src'); i.parentNode.insertBefore(w, i);
    });
    // slider
    var slides = $$('.dw-slide', hero), dots = $('.dw-dots', hero), ctrl = $('.dw-hero-ctrl', hero);
    var cur = 0, timer;
    if (dots) dots.innerHTML = slides.map(function (_, i) { return '<button type="button" aria-label="Go to slide ' + (i + 1) + '"></button>'; }).join('');
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, j) { s.classList.toggle('dw-on', j === cur); s.setAttribute('aria-hidden', j !== cur); s.inert = j !== cur; });
      if (dots) Array.prototype.forEach.call(dots.children, function (d, j) { d.setAttribute('aria-current', j === cur); });
    }
    var restartFill = function () { if (!dots) return; dots.classList.remove('dw-run'); void dots.offsetWidth; dots.classList.add('dw-run'); };
    var play = function () { if (reduce || slides.length < 2) return; clearInterval(timer); timer = setInterval(function () { go(cur + 1); }, 6500); if (ctrl) ctrl.classList.remove('dw-paused'); restartFill(); };
    var prev = $('.dw-hc-prev', hero), next = $('.dw-hc-next', hero);
    if (prev) prev.addEventListener('click', function () { go(cur - 1); play(); });
    if (next) next.addEventListener('click', function () { go(cur + 1); play(); });
    if (dots) dots.addEventListener('click', function (e) { var b = e.target.closest('button'); var i = Array.prototype.indexOf.call(dots.children, b); if (i > -1) { go(i); play(); } });
    hero.addEventListener('mouseenter', function () { clearInterval(timer); if (ctrl) ctrl.classList.add('dw-paused'); });
    hero.addEventListener('mouseleave', play);
    if (slides.length) { go(0); play(); }
    // swipe on phones
    var sx = null;
    hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 45) { go(cur + (dx < 0 ? 1 : -1)); play(); } sx = null; }, { passive: true });

    // countdown
    var chip = $('.dw-cd-chip', hero), tgt = root.getAttribute('data-countdown');
    if (chip && tgt) {
      var target = new Date(tgt), pad = function (n) { return String(n).padStart(2, '0'); };
      var cd = function () {
        var s = (target - new Date()) / 1000;
        if (isNaN(s) || s <= 0) { chip.hidden = true; return; }
        $('[data-cd="d"]', chip).textContent = Math.floor(s / 86400);
        $('[data-cd="h"]', chip).textContent = pad(Math.floor(s % 86400 / 3600));
        $('[data-cd="m"]', chip).textContent = pad(Math.floor(s % 3600 / 60));
      };
      cd(); setInterval(cd, 30000);
    }
    // diya ledge
    var ledge = $('.dw-diya-ledge', hero);
    if (ledge) requestAnimationFrame(function () { ledge.classList.add('dw-lit'); });
    // fireworks
    var cv = $('.dw-id-fireworks', hero);
    if (cv && !reduce && cv.getContext) {
      var ctx = cv.getContext('2d'), W, H, parts = [], vis = true, last = 0, nextB = 900;
      var dpr = Math.min(2, window.devicePixelRatio || 1);
      var size = function () { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); };
      size(); window.addEventListener('resize', size);
      var cols = ['#ffd27a', '#ffb347', '#ff7aa8', '#f59e0b', '#fff1c1'];
      var burst = function () {
        var x = W * (0.06 + Math.random() * 0.5), y = H * (0.1 + Math.random() * 0.28), c = cols[Math.random() * cols.length | 0];
        for (var i = 0; i < 46; i++) { var a = i / 46 * 6.283, s = 1.4 + Math.random() * 1.8; parts.push({ x: x, y: y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, life: 1, c: c }); }
      };
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { vis = es[0].isIntersecting; }).observe(cv);
      var loop = function (t) {
        requestAnimationFrame(loop); if (!vis || document.hidden) return;
        if (t - last > nextB) { burst(); last = t; nextB = 1700 + Math.random() * 1800; }
        ctx.clearRect(0, 0, W, H); parts = parts.filter(function (p) { return p.life > 0; });
        parts.forEach(function (p) {
          p.x += p.vx; p.y += p.vy; p.vy += 0.025; p.vx *= 0.985; p.vy *= 0.985; p.life -= 0.012;
          ctx.globalAlpha = Math.max(0, p.life) * 0.85; ctx.fillStyle = p.c; ctx.beginPath(); ctx.arc(p.x, p.y, 1.6, 0, 6.283); ctx.fill();
        });
        ctx.globalAlpha = 1;
      };
      setTimeout(function () { requestAnimationFrame(loop); }, 1800);
    }
    // category flyout (desktop)
    var side = $('.dw-side', root), mega = $('.dw-mega', root), dataEl = $('.dwl-mega-data', root), MEGA = [];
    try { MEGA = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { MEGA = []; }
    if (side && mega && MEGA.length) {
      var items = $$('ul > li', side), curM = -1, hideT, swT;
      var show = function (i) {
        clearTimeout(hideT);
        if (i === curM && mega.classList.contains('dw-open')) return;
        var d = MEGA[i]; if (!d || !d.l || !d.l.length) return hide();
        curM = i; items.forEach(function (li, k) { li.classList.toggle('dw-on', k === i); });
        mega.innerHTML = '<div class="dw-mega-hd"><h4>' + esc(d.t) + '</h4><a href="' + esc(d.u) + '">View all <span aria-hidden="true">→</span></a></div><ul>' +
          d.l.map(function (x) { return '<li><a role="menuitem" href="' + esc(x[1]) + '">' + esc(x[0]) + '</a></li>'; }).join('') + '</ul>';
        var host = mega.parentElement.getBoundingClientRect(), r = items[i].getBoundingClientRect();
        var wasOpen = mega.classList.contains('dw-open');
        mega.style.transition = wasOpen ? '' : 'none';
        mega.style.maxHeight = (host.height - 12) + 'px';
        var h = mega.offsetHeight, rowMid = r.top - host.top + r.height / 2;
        var top = rowMid - 34; top = Math.max(6, Math.min(top, host.height - h - 6));
        mega.style.top = top + 'px';
        mega.style.setProperty('--arrow', Math.max(18, Math.min(h - 18, rowMid - top)) + 'px');
        if (!wasOpen) { void mega.offsetWidth; mega.style.transition = ''; }
        mega.classList.add('dw-open'); mega.setAttribute('aria-hidden', 'false');
      };
      var hide = function () { curM = -1; mega.classList.remove('dw-open'); mega.setAttribute('aria-hidden', 'true'); items.forEach(function (li) { li.classList.remove('dw-on'); }); };
      var later = function () { clearTimeout(hideT); hideT = setTimeout(hide, 180); };
      var desktop = window.matchMedia('(min-width: 861px)');
      items.forEach(function (li, i) {
        li.addEventListener('mouseenter', function () { if (!desktop.matches) return; clearTimeout(swT); if (curM < 0) show(i); else swT = setTimeout(function () { show(i); }, 90); });
        li.addEventListener('mouseleave', function () { clearTimeout(swT); });
        var a = $('a', li); if (a) a.addEventListener('focus', function () { if (desktop.matches) show(i); });
      });
      side.addEventListener('mouseleave', later);
      var all = $('.dw-all', side); if (all) all.addEventListener('mouseenter', later);
      var h3 = $('h3', side); if (h3) h3.addEventListener('mouseenter', later);
      mega.addEventListener('mouseenter', function () { clearTimeout(hideT); clearTimeout(swT); });
      mega.addEventListener('mouseleave', later);
      mega.addEventListener('focusout', function (e) { if (!mega.contains(e.relatedTarget) && !side.contains(e.relatedTarget)) hide(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
    }
  }

  /* ---------- five days ---------- */
  function initDays(root) {
    var tabsEl = $('.dw-days', root); if (!tabsEl) return;
    var tabs = $$('.dw-day', tabsEl), rails = $$('.dw-rail[data-i]', root);
    var all = function () { return $$('.dw-day', tabsEl); };
    var note = $('.dwl-day-note', root), link = $('.dwl-day-link', root);
    var dayKey = function (y, m, d) { return Date.UTC(y, m - 1, d) / 864e5; };
    var todayIST = function () {
      try {
        var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
        var g = function (t) { return +p.filter(function (q) { return q.type === t; })[0].value; };
        return dayKey(g('year'), g('month'), g('day'));
      } catch (e) { var n = new Date(Date.now() + 330 * 6e4); return dayKey(n.getUTCFullYear(), n.getUTCMonth() + 1, n.getUTCDate()); }
    };
    var keyOf = function (b) { var v = (b.getAttribute('data-date') || '').match(/^(\d{4})-(\d{2})-(\d{2})/); return v ? dayKey(+v[1], +v[2], +v[3]) : null; };
    /* ---- festival status on each tile (all dates are India time) ----
       2+ days ahead -> "In N days"   |  1 day ahead -> live countdown to 00:00 IST
       same day      -> LIVE + confetti |  past        -> "EVENT ENDED" (tile stays visible + clickable) */
    var statusOf = function (k, today) { if (k === null) return ''; var n = k - today; return n > 1 ? 'd' + n : n === 1 ? 'tomorrow' : n === 0 ? 'today' : 'past'; };
    var startOf = function (b) { var v = (b.getAttribute('data-date') || '').match(/^(\d{4}-\d{2}-\d{2})/); return v ? Date.parse(v[1] + 'T00:00:00+05:30') : NaN; };
    var pad2 = function (n) { return n < 10 ? '0' + n : '' + n; };
    var fmtCd = function (ms) { var s = Math.max(0, Math.floor(ms / 1000)); return pad2(Math.floor(s / 3600)) + ':' + pad2(Math.floor(s % 3600 / 60)) + ':' + pad2(s % 60); };
    var CF = ['#ffd27a', '#ff4f8b', '#7cf2c8', '#c38bff', '#ff7a3d', '#fff2b8'];
    var confettiHTML = function () {
      var h = '<span class="dw-confetti" aria-hidden="true">';
      for (var i = 0; i < 18; i++) h += '<i style="--x:' + (3 + Math.random() * 94).toFixed(1) + '%;--d:' + (Math.random() * 2.4).toFixed(2) + 's;--t:' + (2.2 + Math.random() * 1.6).toFixed(2) + 's;--r:' + (Math.random() * 360 | 0) + 'deg;--c:' + CF[i % CF.length] + '"></i>';
      return h + '</span>';
    };
    var cdTimer = 0, repainting = false;
    var tickCd = function () {
      if (document.hidden) return;
      var due = false;
      all().forEach(function (b) {
        if (b.getAttribute('data-status') !== 'tomorrow') return;
        var ms = startOf(b) - Date.now(), c = $('.dw-cd', b);
        if (ms <= 0) due = true; else if (c) c.textContent = fmtCd(ms);
      });
      if (due && !repainting) { repainting = true; paintWhen(); repainting = false; }
    };
    var paintWhen = function () {
      var today = todayIST(), anyTomorrow = false;
      all().forEach(function (b) {
        var k = keyOf(b), w = $('.dw-when', b); if (!w) return;
        var st = statusOf(k, today);
        if (w.getAttribute('data-st') !== st) {
          w.setAttribute('data-st', st);
          if (st === 'tomorrow') w.innerHTML = '<span class="dw-wl">Starts in </span><b class="dw-cd">--:--:--</b>';
          else if (st === 'today') w.textContent = 'LIVE';
          else if (st === 'past') w.textContent = 'EVENT ENDED';
          else if (st) w.textContent = 'In ' + st.slice(1) + ' days';
          else w.textContent = '';
        }
        w.hidden = !st;
        b.setAttribute('data-status', st);
        b.classList.toggle('dw-is-today', st === 'today');
        b.classList.toggle('dw-is-tomorrow', st === 'tomorrow');
        b.classList.toggle('dw-is-past', st === 'past');
        var cf = $('.dw-confetti', b);
        if (st === 'today' && !cf) b.insertAdjacentHTML('beforeend', confettiHTML());
        else if (st !== 'today' && cf) cf.parentNode.removeChild(cf);
        if (st === 'tomorrow') anyTomorrow = true;
      });
      if (anyTomorrow && !cdTimer) cdTimer = setInterval(tickCd, 1000);
      else if (!anyTomorrow && cdTimer) { clearInterval(cdTimer); cdTimer = 0; }
      tickCd();
      return today;
    };
    var today0 = paintWhen();
    setInterval(paintWhen, 60000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) paintWhen(); });
    var cur = 0;
    function showDay(i, anim) {
      var b = tabs[i]; if (!b) return;
      var paint = function () {
        tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i); t.tabIndex = j === i ? 0 : -1; });
        all().forEach(function (t) { if (t.getAttribute('aria-hidden') === 'true') t.setAttribute('aria-selected', +t.getAttribute('data-i') === i); });
        rails.forEach(function (r, j) { r.hidden = j !== i; });
        if (!tabsEl.getAttribute('data-belt') && tabsEl.scrollWidth > tabsEl.clientWidth + 2) {
          var x = b.offsetLeft - (tabsEl.clientWidth - b.offsetWidth) / 2;
          try { tabsEl.scrollTo({ left: x, behavior: anim ? 'smooth' : 'auto' }); } catch (e) { tabsEl.scrollLeft = x; }
        }
        if (note) note.innerHTML = b.getAttribute('data-note') || '';
        if (link) {
          var lt = b.getAttribute('data-link-text');
          link.hidden = !lt; link.textContent = lt || ''; link.href = b.getAttribute('data-link') || '#';
        }
        cur = i;
      };
      if (anim && !reduce) {
        var old = rails[cur], nw = rails[i];
        if (old) old.classList.add('dw-swap');
        setTimeout(function () { paint(); if (old) old.classList.remove('dw-swap'); if (nw) { nw.classList.add('dw-swap'); requestAnimationFrame(function () { requestAnimationFrame(function () { nw.classList.remove('dw-swap'); }); }); } }, 180);
      } else paint();
    }
    var start = 0;
    for (var k = 0; k < tabs.length; k++) { var kk = keyOf(tabs[k]); if (kk !== null && kk >= today0) { start = k; break; } }
    showDay(start, false);
    tabsEl.addEventListener('click', function (e) { var b = e.target.closest('.dw-day'); if (b) showDay(+b.getAttribute('data-i'), true); });
    tabsEl.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var n = (cur + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; showDay(n, true); tabs[n].focus();
    });
    // Mobile: once the strip scrolls into view it glides Dhanteras → Bhai Dooj, then glides back
    // (faster) to Dhanteras, and repeats. Drag to move it by hand; it pauses after a tap.
    if (window.innerWidth < 861 && tabs.length > 2) {
      var ctl = pingPong(tabsEl, 32, 60);
      if (ctl) tabsEl.addEventListener('click', function (e) { var d = e.target.closest('.dw-day'); if (!d) return; if (e.detail && d.blur) d.blur(); ctl.pause(4000); });
    }
  }

  /* ---------- price bands (Under ₹499 / ₹799 / ₹999 / Above ₹999) ---------- */
  function initPrice(root) {
    var tabs = $$('.dw-ptab', root), rails = $$('.dw-rail[data-band]', root), links = $$('.dwl-band-link', root);
    if (!tabs.length) return;
    var show = function (i) {
      tabs.forEach(function (t, j) { t.setAttribute('aria-selected', j === i); t.tabIndex = j === i ? 0 : -1; });
      rails.forEach(function (r, j) { r.hidden = j !== i; });
      links.forEach(function (l, j) { l.hidden = j !== i; });
    };
    tabs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    root.addEventListener('keydown', function (e) {
      if (!e.target.classList || !e.target.classList.contains('dw-ptab') || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      var i = tabs.indexOf(e.target), n = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length; show(n); tabs[n].focus();
    });
  }

  /* ---------- gifts: slot-reel ₹ amounts ---------- */
  function initGifts(root) {
    var nums = $$('.dw-env .dw-amt .dw-cnt', root);
    if (!nums.length || reduce || !('IntersectionObserver' in window)) return;
    var LOOPS = 3;
    nums.forEach(function (c) {
      var digits = String(c.getAttribute('data-to')).split('');
      c.innerHTML = digits.map(function (d, k) {
        var cells = '<i>1</i>';
        for (var l = 0; l < LOOPS + k; l++) for (var n = 0; n < 10; n++) cells += '<i>' + n + '</i>';
        cells += '<i>' + d + '</i>';
        return '<span class="dw-reel"><span class="dw-rstrip">' + cells + '</span></span>';
      }).join('');
    });
    function land(amt, card) {
      amt.classList.remove('dw-rolling'); amt.classList.add('dw-landed');
      if (card) { card.classList.add('dw-amt-glow'); setTimeout(function () { card.classList.remove('dw-amt-glow'); }, 1200); }
      var burst = document.createElement('span'); burst.className = 'dw-burst';
      for (var i = 0; i < 12; i++) { var b = document.createElement('b'); b.style.setProperty('--a', (i * 30 + Math.random() * 12) + 'deg'); b.style.setProperty('--r', (34 + Math.random() * 26) + 'px'); b.style.animationDelay = (Math.random() * 0.08) + 's'; burst.appendChild(b); }
      amt.appendChild(burst); setTimeout(function () { burst.remove(); }, 1100);
    }
    function play(c, delay) {
      var amt = c.closest('.dw-amt'), card = c.closest('.dw-env');
      if (c._busy) return; c._busy = true;
      setTimeout(function () {
        amt.classList.remove('dw-landed'); void amt.offsetWidth;
        amt.classList.add('dw-rolling');
        var strips = $$('.dw-rstrip', c);
        strips.forEach(function (st) { if (st.getAnimations) st.getAnimations().forEach(function (a) { a.cancel(); }); });
        var done = 0;
        strips.forEach(function (st, k) {
          var cells = st.children, steps = cells.length - 1, dur = 1100 + k * 450 + (strips.length === 1 ? 200 : 0);
          // em-based so the final digit stays aligned even if the font size changes later
          // (web font swap, mobile breakpoints, Android text scaling)
          var end = 'translateY(-' + steps + 'em)';
          var anim = st.animate([{ transform: 'translateY(0)' }, { transform: end }], { duration: dur, easing: 'cubic-bezier(.12,.75,.25,1.06)' });
          var fin = function () { st.style.transform = end; if (++done === strips.length) { c._busy = false; land(amt, card); } };
          anim.onfinish = fin; anim.oncancel = function () { st.style.transform = end; };
        });
      }, delay);
    }
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return; io.unobserve(e.target);
        var idx = nums.indexOf(e.target); play(e.target, idx % 2 * 160 + idx * 120);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (c) { io.observe(c); });
    if (window.matchMedia('(hover: hover)').matches) nums.forEach(function (c) {
      var card = c.closest('.dw-env');
      if (card) card.addEventListener('mouseenter', function () { io.unobserve(c); play(c, 0); });
    });
  }

  /* ---------- FAQ ---------- */
  function initFaq(root) {
    var faq = $('.dw-acc', root); if (!faq) return;
    faq.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !faq.contains(b)) return;
      var it = b.parentElement, open = !it.classList.contains('dw-open');
      $$('.dw-it', faq).forEach(function (x) { x.classList.remove('dw-open'); $('button', x).setAttribute('aria-expanded', 'false'); $('.dw-ans', x).hidden = true; $('.dw-tg', x).textContent = '+'; });
      if (open) { it.classList.add('dw-open'); b.setAttribute('aria-expanded', 'true'); $('.dw-ans', it).hidden = false; $('.dw-tg', it).textContent = '−'; }
    });
  }

  /* ---------- phone-only dropdowns (buyers + FAQ): one open at a time ---------- */
  var mq = window.matchMedia('(max-width:860px)');
  function accGroups() { return $$('.dwl .dw-m-acc'); }
  function accSync() {
    accGroups().forEach(function (g) {
      var t = $('.dw-m-acc-t', g); if (!t) return;
      if (mq.matches) { t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0'); t.setAttribute('aria-expanded', g.classList.contains('dw-open')); }
      else { g.classList.remove('dw-open'); t.removeAttribute('role'); t.removeAttribute('tabindex'); t.removeAttribute('aria-expanded'); }
    });
  }
  function accToggle(g) {
    if (!mq.matches) return;
    var willOpen = !g.classList.contains('dw-open');
    accGroups().forEach(function (o) { o.classList.remove('dw-open'); var t = $('.dw-m-acc-t', o); if (t) t.setAttribute('aria-expanded', 'false'); });
    if (willOpen) {
      g.classList.add('dw-open'); $('.dw-m-acc-t', g).setAttribute('aria-expanded', 'true');
      var top = g.getBoundingClientRect().top;
      if (top < 80) window.scrollBy({ top: top - 90, behavior: 'smooth' });
    }
  }
  function initAcc(root) {
    $$('.dw-m-acc', root).forEach(function (g) {
      var t = $('.dw-m-acc-t', g); if (!t || t.getAttribute('data-acc')) return;
      t.setAttribute('data-acc', '1');
      t.addEventListener('click', function () { accToggle(g); });
      t.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && mq.matches) { e.preventDefault(); accToggle(g); } });
    });
    accSync();
  }
  if (mq.addEventListener) mq.addEventListener('change', accSync); else if (mq.addListener) mq.addListener(accSync);

  /* ---------- शुभ दीपावली band: lit diyas + fireworks ---------- */
  function initDeepavali(root) {
    var foot = $('.dw-deepavali', root); if (!foot) return;
    var dp = $('.dw-diyas', foot);
    if (dp) {
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es, ob) { if (es[0].isIntersecting) { dp.classList.add('dw-lit'); ob.disconnect(); } }, { threshold: 0.4 }).observe(dp);
      else dp.classList.add('dw-lit');
    }
    var cv = $('.dw-fw-canvas', foot); if (!cv || !cv.getContext || reduce) return;
    var ctx = cv.getContext('2d');
    var COLORS = ['#ffd27a', '#ffb21a', '#ff7a3d', '#ff4f8b', '#7cf2c8', '#fff2b8', '#c38bff', '#ff3b3b'];
    var W = 0, H = 0, rockets = [], parts = [], visible = false, raf = 0, timer = 0, lastBurst = 0;
    function size() { var d = Math.min(window.devicePixelRatio || 1, 2); W = foot.clientWidth; H = foot.clientHeight; cv.width = W * d; cv.height = H * d; ctx.setTransform(d, 0, 0, d, 0, 0); }
    function band() { var r = foot.getBoundingClientRect(); var top = Math.max(0, -r.top), bot = Math.min(H, window.innerHeight - r.top); return [top, Math.max(top + 120, bot)]; }
    function launch() {
      var b = band(), top = b[0], bot = b[1], span = bot - top;
      var x = W * (0.1 + Math.random() * 0.8), ty = top + span * (0.12 + Math.random() * 0.38), g = 0.10;
      var vy = -Math.sqrt(2 * g * (bot - ty));
      rockets.push({ x: x, y: bot, vx: (Math.random() - 0.5) * 0.8, vy: vy, g: g, ty: ty, c: COLORS[Math.random() * COLORS.length | 0] });
    }
    function burst(r) {
      var n = 60 + (Math.random() * 40 | 0), sc = Math.max(0.8, Math.min(1.5, Math.min(W, H) / 480));
      var c2 = COLORS[Math.random() * COLORS.length | 0], ring = Math.random() < 0.35;
      for (var i = 0; i < n; i++) {
        var a = (i / n) * Math.PI * 2 + Math.random() * 0.15, sp = (ring ? 3.8 : 1.2 + Math.random() * 3.8) * sc;
        parts.push({ x: r.x, y: r.y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, life: 1, decay: 0.010 + Math.random() * 0.012, c: Math.random() < 0.5 ? r.c : c2, tw: Math.random() < 0.3 });
      }
    }
    function frame() {
      ctx.globalCompositeOperation = 'destination-out'; ctx.fillStyle = 'rgba(0,0,0,.22)'; ctx.fillRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = rockets.length - 1; i >= 0; i--) {
        var r = rockets[i], px = r.x, py = r.y; r.x += r.vx; r.y += r.vy; r.vy += r.g;
        ctx.strokeStyle = 'rgba(255,190,90,.75)'; ctx.lineWidth = 2; ctx.lineCap = 'round'; ctx.beginPath(); ctx.moveTo(px, py); ctx.lineTo(r.x, r.y); ctx.stroke();
        ctx.fillStyle = '#fff2b8'; ctx.beginPath(); ctx.arc(r.x, r.y, 2, 0, 7); ctx.fill();
        if (r.vy >= -0.4 || r.y <= r.ty) { burst(r); rockets.splice(i, 1); }
      }
      for (var j = parts.length - 1; j >= 0; j--) {
        var p = parts[j]; p.vx *= 0.985; p.vy = p.vy * 0.985 + 0.045; p.x += p.vx; p.y += p.vy; p.life -= p.decay;
        if (p.life <= 0) { parts.splice(j, 1); continue; }
        ctx.globalAlpha = p.tw ? p.life * (0.4 + Math.random() * 0.6) : p.life * 0.9;
        ctx.fillStyle = p.c; ctx.beginPath(); ctx.arc(p.x, p.y, 2.2, 0, 7); ctx.fill();
      }
      ctx.globalAlpha = 1;
      if (visible || rockets.length || parts.length) raf = requestAnimationFrame(frame);
      else { raf = 0; ctx.clearRect(0, 0, W, H); }
    }
    function start() { if (!raf) raf = requestAnimationFrame(frame); }
    function schedule() { clearTimeout(timer); if (!visible) return; launch(); start(); timer = setTimeout(schedule, 900 + Math.random() * 1300); }
    function finale() { var now = Date.now(); if (now - lastBurst < 4000) return; lastBurst = now; [0, 220, 480, 760].forEach(function (d) { setTimeout(function () { if (visible) { launch(); start(); } }, d); }); }
    size(); window.addEventListener('resize', size);
    if ('ResizeObserver' in window) new ResizeObserver(size).observe(foot);
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) {
      es.forEach(function (e) { visible = e.isIntersecting; if (visible) { finale(); clearTimeout(timer); timer = setTimeout(schedule, 1200); } else clearTimeout(timer); });
    }, { threshold: 0.12 }).observe(foot);
  }

  /* ---------- add to cart (real cart) + toast ---------- */
  var toastEl, toastT;
  function toast(msg, isErr) {
    if (!toastEl) {
      var wrap = document.createElement('div'); wrap.className = 'dwl dwl-toast-wrap';
      wrap.innerHTML = '<div class="dw-toast" role="status" aria-live="polite"><svg width="20" height="20" viewBox="0 0 60 50" aria-hidden="true"><use href="#dwl-miniDiya"/></svg><span></span></div>';
      document.body.appendChild(wrap); toastEl = wrap.firstChild;
    }
    toastEl.classList.toggle('dw-err', !!isErr);
    toastEl.querySelector('span').textContent = msg;
    toastEl.classList.add('dw-show'); clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('dw-show'); }, 2800);
  }
  function freeShip() {
    var el = document.querySelector('[data-free-ship]');
    var v = el ? parseFloat(el.getAttribute('data-free-ship')) : NaN;
    return isNaN(v) ? 599 : v;
  }
  /* ---------- Add to cart -> in-cart quantity bar (same behaviour as the live cards) ----------
     "Add to cart" adds the minimum quantity; the button then turns into a − qty + bar that edits the
     real cart line (debounced). Going below the minimum removes the line and brings the button back.
     Every card for the same variant (in any section) stays in sync with the cart. */
  var cartQty = {}, pending = {}, timers = {};
  function rules(buy) { return { min: +buy.getAttribute('data-min') || 1, step: +buy.getAttribute('data-step') || 1, max: +buy.getAttribute('data-max') || 0 }; }
  function paintVariant(id, q) {
    $$('.dwl .dw-buy[data-variant-id="' + id + '"]').forEach(function (buy) {
      var add = $('.dw-add', buy), step = $('.dw-qbar', buy), r = rules(buy);
      if (q > 0) {
        add.hidden = true; step.hidden = false; $('.dw-qbar-q', step).textContent = q;
        $('[data-d="1"]', step).disabled = !!(r.max && q + r.step > r.max);
      } else { step.hidden = true; add.hidden = false; }
    });
  }
  function syncFromCart(cart) {
    var next = {};
    (cart.items || []).forEach(function (it) { next[it.variant_id] = (next[it.variant_id] || 0) + it.quantity; });
    var ids = {};
    $$('.dwl .dw-buy[data-variant-id]').forEach(function (b) { ids[b.getAttribute('data-variant-id')] = 1; });
    Object.keys(ids).forEach(function (id) { if (pending[id] === undefined) { cartQty[id] = next[id] || 0; paintVariant(id, cartQty[id]); } });
  }
  function announce(cart) {
    ['dd:cart-added', 'cart:refresh', 'cart:updated'].forEach(function (n) { document.dispatchEvent(new CustomEvent(n, { detail: { cart: cart, source: 'dwl-home' } })); });
    try { if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dwl-home', cartData: cart }); } catch (err) {}
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    if (bubble) bubble.textContent = cart.item_count;
  }
  var getCart = function () { return fetch(ROOT_URL + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); };
  var refreshT;
  function refresh() { clearTimeout(refreshT); refreshT = setTimeout(function () { getCart().then(syncFromCart).catch(function () {}); }, 150); }

  // first add
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.dwl .dw-add[data-variant-id]');
    if (!b || b.disabled || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    var buy = b.closest('.dw-buy'), id = b.getAttribute('data-variant-id'), q = buy ? rules(buy).min : 1;
    b.setAttribute('aria-busy', 'true');
    fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: q }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart'); return d; }); })
      .then(getCart)
      .then(function (cart) {
        syncFromCart(cart);
        /* success message comes from the store's own "Product added in cart" notice */
        announce(cart);
      })
      .catch(function (err) { toast(err.message || 'Could not add to cart', true); })
      .then(function () { b.removeAttribute('aria-busy'); });
  });

  // − / + on the in-cart bar
  document.addEventListener('click', function (e) {
    var sb = e.target.closest && e.target.closest('.dwl .dw-qbar-b');
    if (!sb || sb.disabled) return;
    e.preventDefault();
    var buy = sb.closest('.dw-buy'), id = buy.getAttribute('data-variant-id'), r = rules(buy);
    var cur = pending[id] !== undefined ? pending[id] : (cartQty[id] || 0);
    var d = +sb.getAttribute('data-d'), q = cur + d * r.step;
    if (d < 0 && q < r.min) q = 0;
    if (r.max && q > r.max) q = r.max;
    if (q === cur) return;
    pending[id] = q; paintVariant(id, q);
    clearTimeout(timers[id]);
    timers[id] = setTimeout(function () {
      var want = pending[id];
      fetch(ROOT_URL + 'cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(id), quantity: want })
      }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || 'Could not update the cart'); return d; }); })
        .then(function (cart) {
          if (pending[id] === want) delete pending[id];
          syncFromCart(cart); announce(cart);
          var got = cartQty[id] || 0;
          if (want > 0 && got < want) toast('Only ' + got + ' available for this item.', true);
        })
        .catch(function (err) { delete pending[id]; toast(err.message, true); refresh(); });
    }, 350);
  });

  // keep in step with cart changes made elsewhere (cart drawer, other tabs)
  ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (n) { document.addEventListener(n, function (e) { if (!(e.detail && e.detail.source === 'dwl-home')) refresh(); }); });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh); else refresh();

  /* ---------- boot ---------- */
  function init(root) {
    if (!root || root.getAttribute('data-dwl-ready')) return;
    root.setAttribute('data-dwl-ready', '1');
    decor(root);
    photoCards(root);
    var type = root.getAttribute('data-dwl');
    if (type === 'hero') initHero(root);
    if (type === 'days') initDays(root);
    if (type === 'deals') belt($('.dw-cd-track', root), root, 46, 34);
    if (type === 'price') initPrice(root);
    if (type === 'gifts') initGifts(root);
    if (type === 'faq') initFaq(root);
    if (type === 'buyers' || type === 'faq') initAcc(root);
    if (type === 'deepavali') initDeepavali(root);
  }
  function boot() { ensureDefs(); $$('[data-dwl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { ensureDefs(); $$('[data-dwl]', e.target).forEach(init); });
})();